import { Component, Input, numberAttribute, OnChanges } from '@angular/core';
import { TuiDay, TuiDayRange } from '@taiga-ui/cdk';
import {
  TuiAxes,
  TuiBarChart,
  TuiLineChart,
} from '@taiga-ui/addon-charts';
import { TuiHint } from '@taiga-ui/core';
import { TelesuiviGraphiqueHintObservanceEtIahrComponent } from '../../telesuivi-graphique-hint/telesuivi-graphique-hint-observance-et-iahr/telesuivi-graphique-hint-observance-et-iahr.component';
import { CoordonneesGraphiquePipe } from '../../../pipes/coordonnees-graphique.pipe';
import { Observance } from '../../../models/observance';

@Component({
  selector: 'app-telesuivi-graphique-observance-et-iahr',
  standalone: true,
  imports: [
    TuiAxes,
    TuiBarChart,
    TuiLineChart,
    TuiHint,
    TelesuiviGraphiqueHintObservanceEtIahrComponent,
    CoordonneesGraphiquePipe,
  ],
  templateUrl: './telesuivi-graphique-observance-et-iahr.component.html',
  styleUrl: './telesuivi-graphique-observance-et-iahr.component.scss',
})
export class TelesuiviGraphiqueObservanceEtIahrComponent implements OnChanges {
  @Input() observanceList: Observance[] | undefined;
  @Input() periode: TuiDayRange = new TuiDayRange(
    TuiDay.currentLocal().append({ month: -2 }),
    TuiDay.currentLocal()
  );

  obsList: number[] = [];
  iahrList: Array<number> = [];
  dateList: Date[] = [];

  ngOnChanges(): void {
    this.obsList = [];
    this.iahrList = [];
    this.dateList = [];

    var i: number = 0;

    // preparation dateDebut & dateFin
    var dateDebut: Date | undefined;
    var dateFin: Date | undefined;
    if (this.periode) {
      dateDebut = new Date(
        this.periode.from.year,
        this.periode.from.month,
        this.periode.from.day
      );
      dateFin = new Date(
        this.periode.to.year,
        this.periode.to.month,
        this.periode.to.day
      );
    }

    if (this.observanceList && dateDebut && dateFin) {
      this.observanceList.forEach(
        (observance: Observance) => {
          if (
            observance.date &&
            observance.date >= dateDebut! &&
            observance.date <= dateFin!
          ) {
            this.obsList.push(observance.obs ?? null!);
            this.iahrList.push(observance.iahResiduel || null!);
            this.dateList.push(observance.date || null!);

          }
        }
      );
    }
  }
}
